




import { Component, Vue, Prop } from "vue-property-decorator";
import { RequestModel, unsuccessfulTaskCount, completedTaskCount, isComplete, hasUnsuccessfulTasks, getStatus, RequestStatus } from "@/api/Requests";
import { requestIcon } from "@/assets/icons/RequestIcons";

@Component
class RequestStatusIcon extends Vue {
  @Prop() readonly request?: RequestModel;

  unsuccessfulTaskCount = unsuccessfulTaskCount;
  completedTaskCount = completedTaskCount;
  isComplete = isComplete;
  hasUnsuccessfulTasks = hasUnsuccessfulTasks;

  icon() {
    if (!this.request) return "";
    return requestIcon(getStatus(this.request));
  }

  get tooltipMessage() {
    if (!this.request) return "";
    const status = getStatus(this.request);
    switch (status) {
      case RequestStatus.InProgress:
        return this.requestInProgressMessage();
      case RequestStatus.InProgressWithErrors:
        return this.requestInProgressWarningMessage();
      case RequestStatus.Complete:
        return "All tasks completed successfully";
      case RequestStatus.CompleteWithErrors:
        return this.requestCompleteWarningMessage();
      case RequestStatus.Cancelled:
        return "Request was cancelled";
      case RequestStatus.Pending:
        return "Request Pending";
    }
    return "";
  }

  requestCompleteWarningMessage() {
    if (!this.request) return "";
    const unsuccessfulCount = unsuccessfulTaskCount(this.request);
    if (unsuccessfulCount === 1) return `${this.unsuccessfulTaskCount(this.request)} task was unsuccessful`;
    return `${unsuccessfulTaskCount(this.request)} tasks were unsuccessful`;
  }

  requestInProgressMessage() {
    if (!this.request) return "";
    const inProgressCount = this.request.tasks.length - this.completedTaskCount(this.request);
    if (inProgressCount === 1) return "1 task in progress";
    return `${inProgressCount} tasks in progress`;
  }

  requestInProgressWarningMessage() {
    if (!this.request) return "";
    const inProgressTaskCount = this.request.tasks.length - this.completedTaskCount(this.request);
    let inProgressTasksMessage = `${inProgressTaskCount} tasks in progress`;
    if (inProgressTaskCount === 1) inProgressTasksMessage = "1 task in progress";

    const unsuccessfulTaskCount = this.unsuccessfulTaskCount(this.request);
    let unsuccessfulTasksMessage = `${unsuccessfulTaskCount} tasks were unsuccessful`;
    if (unsuccessfulTaskCount === 1) unsuccessfulTasksMessage = "1 task was unsuccessful";
    return `${inProgressTasksMessage}, but ${unsuccessfulTasksMessage}`;
  }
}

export default RequestStatusIcon;
